<template>
  <v-app class="app">
    <template v-if="!publicPage">
      <v-layout>
        <v-main>
          <app-toolbar />
          <app-drawer />
          <app-banner />
          <app-page-header />
          <router-view />
        </v-main>

        <app-fab />
        <app-snack-bar />
        <app-snack-bar-content />
      </v-layout>
    </template>

    <template v-else>
      <!-- <transition>
        <keep-alive>
          <router-view :key="$route.fullPath" />
        </keep-alive>
      </transition> -->
      <router-view :key="$route.fullPath" />
    </template>
  </v-app>
</template>

<script>
import Vue from "vue";

import HasPrivilleges from "@/directives/privilleges";

export default Vue.extend({
  name: "App",
  components: {
    AppFab: () => import(/* webpackPrefetch: true */ "@/components/AppFab"),
    AppBanner: () =>
      import(/* webpackPrefetch: true */ "@/components/AppBanner"),
    AppDrawer: () =>
      import(/* webpackPrefetch: true */ "@/components/AppDrawer"),
    AppPageHeader: () =>
      import(/* webpackPrefetch: true */ "@/components/AppPageHeader"),
    AppToolbar: () =>
      import(/* webpackPrefetch: true */ "@/components/AppToolbar"),
    AppSnackBar: () =>
      import(/* webpackPrefetch: true */ "@/components/AppSnackBar"),
    AppSnackBarContent: () =>
      import(/* webpackPrefetch: true */ "@/components/AppSnackBarContent"),
  },
  directives: {
    HasPrivilleges,
  },
  computed: {
    publicPage() {
      const {
        fullPath,
        meta: { publicPage },
      } = this.$route;
      return fullPath === "/" ? true : publicPage;
    },
  },
});
</script>

<style lang="scss">
@import "@/assets/styles/index.scss";
.app {
  background-color: #f5f5f5 !important;
  &-main {
    min-height: 590px;
  }
}

.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}
</style>
